module.exports = __webpack_public_path__ + "img/file-excel.b540e633.svg";